<div class="modal-header">
    <h4 class="modal-title fw-bold" id="headerTitle" jhiTranslate="inventoryManagerApp.lot.import.deposits.title">
        Import lot deposits
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="close()">
    </button>
</div>
<div class="mb-3 row mt-3">
    <div class="col-2"></div>
    <div class="col-md-8">
        <label class="form-label"  for="fileUpload"><i class="fa fa-search"></i> {{"inventoryManagerApp.lot.import.deposits.field.file" | translate}}</label>

		<jhi-file-select id="fileUpload"
						 [acceptedFileTypes]="selectedFileType"
						 (fileSelected)="onFileChange($event)"
						 (fileCleared)="clearSelectedFile()">
		</jhi-file-select>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="close()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button (click)="import()" class="btn btn-primary" [disabled]="fileName === '' ? 'disabled' : null">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.import">Import</span>
    </button>
</div>
